export type Role = "architect" | "contributor" | "admin";

/** Map the raw Better Auth role string to a Markyt Role. Legacy "user" → architect. */
export function normalizeRole(raw: string | null | undefined): Role {
  if (raw === "contributor" || raw === "admin" || raw === "architect") return raw;
  return "architect";
}

export function canContribute(role: Role): boolean {
  return role === "contributor" || role === "admin";
}

export function canGovern(role: Role): boolean {
  return role === "admin";
}
